import React, {Component} from 'react'
import { Field } from 'redux-form'
import { useTranslation, Trans } from "react-i18next";



const SelectComp = ({input, selectProps, options, meta: {error, touched}}) => {
    const { t, i18n } = useTranslation();
    return <div><select {...input} {...selectProps}  className={['form-control', (error && touched ? 'is-invalid' : '')].join(" ")} >
    <option value="">{t('forms.select')}</option>
    {options ? options.map((o) => <option value={o.value} key={o.value} >{o.name}</option>) : null}	
    </select>
    {touched && Array.isArray(error) && error.map(e => <small className="text-danger" key={typeof(e) === 'string' ? error : e.code}><i><Trans values={e}>validations.{typeof(e) === 'string' ? `${error}` : e.code }</Trans></i></small>)}
    </div>
}




const Select = ({name, selectProps, options}) => {
    
    return <Field name={name} component={SelectComp} options={options} selectProps={selectProps}  />
}

export default Select
